import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: () => import('@/views/index/index'),
      meta: {
        title: '委托单查询',
        // 缓存首页
        keepAlive: true
      }
    },
    {
      path: '/cart',
      meta: {
        title: '委托单详情'
      },
      component: () => import('@/views/cart/index')
    },
    {
      path: '/addOrders',
      component: () => import('@/views/addOrders/index'),
      meta: {
        title: '新增委托单',
        // 缓存首页
        keepAlive: true
      }
    },
    {
      path: '/ccOrderDetail',
      component: () => import('@/views/ccOrderDetail/index'),
      meta: {
        title: '委托单详情',
        // 缓存首页
        keepAlive: true
      }
    },
    {
      path: '/myorders',
      component: () => import('@/views/myOrders/index'),
      meta: {
        title: '我的委托单',
        // 缓存首页
        keepAlive: true
      }
    },
    {
      path: '/my',
      component: () => import('@/views/my/index'),
      redirect: '/my/center',
      children: [
        {
          path: 'center',
          meta: {
            title: '个人中心'
          },
          component: () => import('@/views/my/children/center')
        },
        {
          path: 'set',
          meta: {
            title: '设置'
          },
          component: () => import('@/views/my/children/set')
        }
      ]
    },
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '账号绑定'
      }
    },
    {
      path: '/lottery',
      component: () => import('@/views/lottery/index'),
      meta: {
        title: '抽奖'
      }
    },
    {
      path: '*',
      component: () => import('@/components/NotFound')
    }
  ]
})

router.beforeEach((to, from, next) => {
  let { title, needLogin } = to.meta
  let { isLogin } = store.state
  document.title = title

  if (needLogin && !isLogin) {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})

export default router
